module.exports = __webpack_public_path__ + "assets/img/inforMation.b6644637.png";